import React from 'react';

import { Box } from '@mui/system';
import { Skeleton, Typography } from '@mui/material';

import { SKELETON_BGCOLOR, SKELETON_ANIMATION } from '../../utils/constants/dlxDriveConstants';

// ----------------------------------------------------------------------

const DocumentAccompanyingDocumentElementSkeleton: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 2,
    }}
  >
    <Skeleton
      sx={{ backgroundColor: SKELETON_BGCOLOR, borderRadius: '4px', ml: '8px' }}
      animation={SKELETON_ANIMATION}
      variant="rectangular"
      width={30}
      height={40}
    />

    <Box sx={{ flex: 1 }}>
      <Typography component="div" variant="subtitle2" sx={{ width: '80%' }}>
        <Skeleton animation={SKELETON_ANIMATION} sx={{ backgroundColor: SKELETON_BGCOLOR }} />
      </Typography>

      <Typography component="div" variant="subtitle2" sx={{ width: '80%' }}>
        <Skeleton animation={SKELETON_ANIMATION} sx={{ backgroundColor: SKELETON_BGCOLOR }} />
      </Typography>
    </Box>

    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1,
        mr: 1,
      }}
    >
      <Skeleton
        sx={{ backgroundColor: SKELETON_BGCOLOR, borderRadius: '4px', ml: '8px' }}
        animation={SKELETON_ANIMATION}
        variant="rectangular"
        width={22}
        height={22}
      />

      <Skeleton
        sx={{ backgroundColor: SKELETON_BGCOLOR, borderRadius: '4px', ml: '8px' }}
        animation={SKELETON_ANIMATION}
        variant="rectangular"
        width={22}
        height={22}
      />
    </Box>
  </Box>
);

export default DocumentAccompanyingDocumentElementSkeleton;
